import {

  Plus,
  RotateCw,
} from "lucide-react";

import { useState } from "react";
import CreateProjectDrawer from "../../create/CreateProjectDrawer"

const DashboardHeader = () => {
  const [openCreateProject, setOpenCreateProject] =
    useState(false);

  return (
    <>
      <div className="flex items-center justify-between">

       {/* Left Section */}
<div className="flex items-start">
  <div>
    <h2 className="text-2xl font-bold leading-tight text-gray-900">
      Project Dashboard
    </h2>

    <p className="mt-1 text-sm text-gray-500">
      Monitor projects,team progress and overall performance.
    </p>
  </div>
</div>
        {/* Right Section */}

        <div className="flex flex-wrap items-center gap-2">

         


          {/* New Project */}

          <button
            type="button"
            onClick={() => setOpenCreateProject(true)}
            className="flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-xs font-medium text-white hover:bg-blue-700"
          >
            <Plus size={16} />
            New Project
          </button>

        </div>
      </div>

      {/* Create Project Drawer */}

      <CreateProjectDrawer
        open={openCreateProject}
        onClose={() => setOpenCreateProject(false)}
      />

    </>
  );
};

export default DashboardHeader;